import React, { useContext } from 'react';
import { compose, join, map, pathOr, split } from 'ramda';
import Drawer, { DrawerProps } from '@material-ui/core/Drawer';
import { DrawerContainer } from 'src/components/ConfirmationDialog/styled-components';
import Routes from '../../modules/Navigator/Navigator.route';
import NavLink from '../Navlink/Navlink.component';
import { APP_CONSTANT } from 'src/constants';
import { AppContext } from 'src/context/AppContextProvider';
import { t } from 'src/i18n';

interface RightModalProps {
  children?: React.ReactElement;
  anchor?: DrawerProps['anchor'];
  open: boolean;
  closeDrawer(event: React.MouseEvent<HTMLButtonElement | Document>): void;
  headerComponent?: React.ReactElement;
  footerComponent?: React.ReactElement;
  minWidth?: number;
  disableEnforceFocus?: boolean;
  className?: string;
  maxWidth?: number;
  cookies: {
    userInfo: {
      name: { nameFirst: string; nameLast: string };
    };
    role: string;
  };
}

const RightModal = (props: RightModalProps): React.ReactElement => {
  const isLoggedInUser = [
    APP_CONSTANT.ROLE_SINGLE_USER,
    APP_CONSTANT.ROLE_LEGAL_GUARDIAN
  ].includes(props.cookies.role);

  const context = useContext(AppContext);

  const transformNameToShortText = compose(
    join(''),
    map((item) => item[0]),
    split(' ')
  );

  const {
    open,
    anchor = 'right',
    closeDrawer,
    minWidth,
    disableEnforceFocus = false,
    className = '',
    maxWidth,
    cookies,
  } = props;


  return (
    <Drawer
      variant="temporary"
      anchor={anchor}
      open={open}
      onClose={closeDrawer}
      transitionDuration={500}
      data-testid="drawer menu"
      ModalProps={{ disableEnforceFocus }}
      className={className}
      onEscapeKeyDown={closeDrawer}
      onBackdropClick={closeDrawer}
    >
      <DrawerContainer minWidth={minWidth} maxWidth={maxWidth}>
        <div className="navbar__navlink-group-mobile">
          {isLoggedInUser ? (
            <>
              <div className="navbar__user-wrapper-mobile">
                <div className="navbar__short-name-block">
                  <p className="navbar__short-name-text">
                    {transformNameToShortText(
                      `${pathOr('', ['userInfo', 'name', 'nameFirst'])(
                        cookies
                      )} ${pathOr('', ['userInfo', 'name', 'nameMiddle'])(
                        cookies
                      )} ${pathOr('', ['userInfo', 'name', 'nameLast'])(
                        cookies
                      )}`
                    )}
                  </p>
                </div>
                <p className="navbar__user-name">
                  {`${pathOr('', ['userInfo', 'name', 'nameFirst'])(
                    cookies
                  )} ${pathOr('', ['userInfo', 'name', 'nameMiddle'])(
                    cookies
                  )} ${pathOr('', ['userInfo', 'name', 'nameLast'])(cookies)}`}
                </p>
              </div>
              <NavLink
                to={Routes.Dashboard}
                title={'Dashboard'}
                className="mr-30 navlink-mobile"
              />
              <NavLink
                to={Routes.PatientDocument}
                title={'Patient Documents'}
                className="mr-30"
              />
              <NavLink
                to={Routes.ResetPassword}
                title={t('navbar.menu.button.reset')}
              />
              <NavLink
                to={Routes.SignIn}
                title={t('navbar.menu.button.signOut')}
              />
            </>
          ) : (
            <>
              {context.isOABFormPublished &&
                <NavLink
                  to={Routes.Dashboard}
                  title={'Dashboard'}
                  className="mr-30 navlink-mobile"
                />
              }
              <NavLink
                to={Routes.PatientDocument}
                title={'Patient Documents'}
                className="mr-30"
              />

              <NavLink
                to={Routes.SignIn}
                title={t('signIn.button.signIn')}
                className="mr-30"
              />

              <NavLink
                to={Routes.Register}
                title={t('general.register')}
                className="mr-30"
              />
            </>
          )}
        </div>
      </DrawerContainer>
    </Drawer>
  );
};

export default RightModal;
